module.exports = __webpack_public_path__ + "assets/img/27_1385_big.6f896f9e.jpg";